<template>
	<div class="pages b-t-1">
		<div>
			<section class="box filter-wapper">
				<div class="fx fx-wrap box-flex"></div>
				<z-search v-model="params.search" placeholder="请输入活动名称" @handleSearch="handleOffset(0)"></z-search>
			</section>
			<div>
				<z-table :offset="params.offset" :count="params.count" :total-count="promotions.item_total" @handleOffset="handleOffset">
					<th slot="columns" v-for="item in columns">{{item}}</th>
					<tr slot="datasource" v-for="(item, index) in promotions.list || []">
						<td>{{item.name}}</td>
						<td>{{item.start_time | momentFmt }} 至 {{item.end_time | momentFmt }}</td>
						<td>{{item.c_time | momentFmt}}</td>
						<td class="operating">
							<router-link  class="operat-btn" tag="a" :to="{ name: 'promotionsInfo',query:{id: item.id}}"><i class="icon-look"></i><span>详情</span></router-link>
							<router-link  class="operat-btn" tag="a" :to="{ name: 'editPromotions',query:{id: item.id}}"><i class="icon-edit"></i><span>编辑</span></router-link>
							<el-popover
						  	placement="top"
						  	width="200"
						  	:ref="'popover_'+index"
						  	>
						  		<div class="z-popover">
							  		<div>确定要删除此活动?</div>
							  		<div @click="handleClosePopover(index)"  class="pop-btns-cont">
							  			<a class="pop-btn-cancle">取消</a>
							  			<a @click="handleDeletePromotion(item.id)" class="pop-btn-confirm">确定</a>
							  		</div>
							  	</div>
								<a slot="reference" class="operat-btn"><i class="icon-del"></i><span>删除</span></a>
						  	</el-popover>
						</td>
					</tr>
					<div slot="operate">
						<router-link class="z-btn z-btn-primary b-r-3" :to="{ name: 'editPromotions'}">新增活动</router-link>
					</div>
				</z-table>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'PromotionsPage',
		components: {},
		data() {
			return {
				columns: ['活动名称', '有效期', '更新时间', '操作'],
				params: {
					offset: 0, //分页偏移量
					count: 10, //每页多少条
					search: '',//搜索条件
				}
			}
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				promotions: state => state.promotions.list,
			})
		},
		mounted() {
			this.handleGetPromotionList();
		},
		/*
		 * 事件处理
		 */
		methods: {
			//关闭popover
			handleClosePopover(index) {
				if(typeof(this.$refs['popover_'+index])!="undefined") this.$refs['popover_'+index][0].doClose();
			},
			
			//获取满减活动列表
			async handleGetPromotionList() {
				this.$log(this.params);
				await this.getPromotionList(this.params);
			},
			
			async handleOffset(offset) {
				this.params.offset = offset;
				await this.getPromotionList(this.params);
				this.$log('请求促销列表数据成功');
			},
			
			//删除活动
			async handleDeletePromotion(id) {
				try {
					await this.deletePromotion({entityId: id});
					this.handleGetPromotionList();
					this.$success('删除成功');
				} catch (e) {
					this.$errorMsg('删除失败');
				}
			},
			
			...mapActions(['getPromotionList', 'deletePromotion']),
		},
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.filter-wapper{
		border-top: none;
	}
</style>


// WEBPACK FOOTER //
// PromotionsPage.vue?d5a9083e